import {MfaApplication} from "../api/types";

export class MfaApplications {
    mfaApplications: {[id: string]: MfaApplication};

    constructor(applications: MfaApplication[]) {
        this.mfaApplications = {};
        for (let app of applications) {
            this.mfaApplications[app.id] = app;
        }
    }

    public getMfaApplication(id: string): MfaApplication|undefined {
        return this.mfaApplications[id];
    }

    public getMfaApplications(): MfaApplication[] {
        let res: MfaApplication[] = [];
        for (let appId of Object.keys(this.mfaApplications)) {
            res.push(this.mfaApplications[appId]);
        }
        return res;
    }
}
